// This file is used to prevent circular dependencies between the elementModalSelector and elementSelector

export const getCurrentModalElementId = (state) => state.getIn(['app', 'modal', 'elementModal', 'elementId']);

export const getIsElementOpenInModal = (state, ownProps) => getCurrentModalElementId(state) === ownProps.elementId;
